import { Tournaments } from '@/routes/Tournaments';

/**
 * Events — global (public) tournaments only, no tabs. The old single Tournaments
 * panel's three tabs (global / sit&go / community) are now three separate Hub
 * sections; this one pins the `tournaments` view.
 *
 * Declared `ownScroll` in HubSections: <Tournaments /> pins nothing above and
 * scrolls only its list. `-mx-4` cancels the Hub padding since Tournaments
 * brings its own `px-4`.
 */
export function EventsPanel() {
  return (
    <div className="-mx-4 h-full">
      <Tournaments forcedView="tournaments" />
    </div>
  );
}
